import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import db from "../Firebase";

const Q1_START = new Date("2026-01-01T00:00:00");
const Q1_END = new Date("2026-05-31T23:59:59");

const FY_START = new Date("2025-04-01T00:00:00");
const FY_END   = new Date("2026-03-31T23:59:59");
const FY_MONTHS = [
    { label: "Apr'25", start: new Date("2025-04-01T00:00:00"), end: new Date("2025-04-30T23:59:59") },
    { label: "May'25", start: new Date("2025-05-01T00:00:00"), end: new Date("2025-05-31T23:59:59") },
    { label: "Jun'25", start: new Date("2025-06-01T00:00:00"), end: new Date("2025-06-30T23:59:59") },
    { label: "Jul'25", start: new Date("2025-07-01T00:00:00"), end: new Date("2025-07-31T23:59:59") },
    { label: "Aug'25", start: new Date("2025-08-01T00:00:00"), end: new Date("2025-08-31T23:59:59") },
    { label: "Sep'25", start: new Date("2025-09-01T00:00:00"), end: new Date("2025-09-30T23:59:59") },
    { label: "Oct'25", start: new Date("2025-10-01T00:00:00"), end: new Date("2025-10-31T23:59:59") },
    { label: "Nov'25", start: new Date("2025-11-01T00:00:00"), end: new Date("2025-11-30T23:59:59") },
    { label: "Dec'25", start: new Date("2025-12-01T00:00:00"), end: new Date("2025-12-31T23:59:59") },
    { label: "Jan'26", start: new Date("2026-01-01T00:00:00"), end: new Date("2026-01-31T23:59:59") },
    { label: "Feb'26", start: new Date("2026-02-01T00:00:00"), end: new Date("2026-02-28T23:59:59") },
    { label: "Mar'26", start: new Date("2026-03-01T00:00:00"), end: new Date("2026-03-31T23:59:59") },
];

const MONTHS = [
    { label: "Jan'26", start: new Date("2026-01-01T00:00:00"), end: new Date("2026-01-31T23:59:59") },
    { label: "Feb'26", start: new Date("2026-02-01T00:00:00"), end: new Date("2026-02-28T23:59:59") },
    { label: "Mar'26", start: new Date("2026-03-01T00:00:00"), end: new Date("2026-03-31T23:59:59") },
    { label: "Apr'26", start: new Date("2026-04-01T00:00:00"), end: new Date("2026-04-30T23:59:59") },
    { label: "May'26", start: new Date("2026-05-01T00:00:00"), end: new Date("2026-05-31T23:59:59") },
];

const toDate = (val) => {
    if (!val) return null;
    if (val?.toDate) return val.toDate();
    if (val instanceof Date) return val;
    const d = new Date(val);
    return isNaN(d) ? null : d;
};

const inRange = (val, start, end) => {
    const d = toDate(val);
    return d && d >= start && d <= end;
};

const fmtDate = (val) => {
    const d = toDate(val);
    if (!d) return val ? String(val) : "—";
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
};

const fmtVal = (val) => {
    if (val === null || val === undefined || val === "") return "—";
    const d = toDate(val);
    if (d && val?.toDate) return fmtDate(val); // only format if it was actually a Timestamp/Date
    return String(val);
};

const CARD_COLORS = [
    "#4361ee", "#7209b7", "#f72585", "#4cc9f0",
    "#3a0ca3", "#480ca8", "#560bad", "#f3722c",
    "#4895ef", "#3f37c9", "#0d9488", "#e11d48",
    "#0891b2", "#d97706",
];

const ICONS = ["📲", "👥", "🎓", "⏱️", "🏅", "🔁", "🖼️", "📢", "🏙️", "🗺️", "💼", "📜", "🪪", "🏷️"];

// ── Modal ─────────────────────────────────────────────────────────────────────
function DataModal({ modal, onClose }) {
    if (!modal) return null;
    return (
        <div
            onClick={onClose}
            style={{
                position: "fixed", inset: 0, background: "rgba(0,0,0,0.65)",
                zIndex: 9999, display: "flex", alignItems: "flex-start",
                justifyContent: "center", overflowY: "auto", padding: "40px 16px",
            }}
        >
            <div
                onClick={e => e.stopPropagation()}
                style={{
                    background: "#fff", borderRadius: "18px", width: "100%",
                    maxWidth: "860px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
                    overflow: "hidden",
                }}
            >
                {/* Modal Header */}
                <div style={{ background: modal.color, padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div>
                        <h5 className="text-white fw-bold mb-0">{modal.icon} {modal.title}</h5>
                        <small style={{ color: "rgba(255,255,255,0.8)" }}>{modal.label} · {modal.data.length} records</small>
                    </div>
                    <button onClick={onClose} style={{ background: "rgba(255,255,255,0.2)", border: "none", borderRadius: "50%", width: 32, height: 32, color: "#fff", fontSize: 16, cursor: "pointer" }}>✕</button>
                </div>

                {/* Modal Body */}
                <div style={{ maxHeight: "60vh", overflowY: "auto", padding: "0" }}>
                    {modal.data.length === 0 ? (
                        <div className="text-center text-muted py-5">No records found</div>
                    ) : (
                        <table className="table table-sm table-hover mb-0" style={{ fontSize: "13px" }}>
                            <thead style={{ position: "sticky", top: 0, background: "#f8f9fa", zIndex: 1 }}>
                                <tr>
                                    <th style={{ padding: "10px 16px", width: 40 }}>#</th>
                                    {modal.fields.map(f => (
                                        <th key={f.key} style={{ padding: "10px 16px" }}>{f.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {modal.data.map((row, i) => (
                                    <tr key={i}>
                                        <td style={{ padding: "8px 16px", color: "#94a3b8" }}>{i + 1}</td>
                                        {modal.fields.map(f => (
                                            <td key={f.key} style={{ padding: "8px 16px" }}>{fmtVal(row[f.key])}</td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
}

// ── Main Page ─────────────────────────────────────────────────────────────────
export default function DataMetrix() {
    const [metrics, setMetrics] = useState(null);
    const [fyDownloads, setFyDownloads] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [modal, setModal] = useState(null);

    useEffect(() => { fetchAll(); }, []);

    const openModal = (title, icon, color, data, fields, label) => {
        setModal({ title, icon, color, data, fields, label });
    };

    const fetchAll = async () => {
        setLoading(true);
        setError(null);
        try {
            const [
                downloadSnap, activitySnap, workshopSnap,
                regSnap, portfolioSnap, collateralSnap, parlourSnap, certSnap, profileTypeSnap,
            ] = await Promise.all([
                getDocs(collection(db, "personal_details")),
                getDocs(collection(db, "users_activity")),
                getDocs(collection(db, "workshop_event_data")),
                getDocs(collection(db, "workshop_registration")),
                getDocs(collection(db, "nv_portfolio_details")),
                getDocs(collection(db, "nv_orders_data")),
                getDocs(collection(db, "parlour_name")),
                getDocs(collection(db, "downloaded_cretificate_data")),
                getDocs(collection(db, "profile_type")),
            ]);

            // ── 1. Downloads ─────────────────────────────────────────────
            const dlFilter = (s, e) => downloadSnap.docs.filter(d => inRange(d.data().created_date, s, e));
            const dlDocs = dlFilter(Q1_START, Q1_END);
            const dlByMonth = MONTHS.map(m => dlFilter(m.start, m.end));
            const dlFields = [{ key: "phone_no", label: "Phone" }, { key: "name", label: "Name" }, { key: "created_date", label: "Created Date" }];

            // ── 2. Active users ───────────────────────────────────────────
            const auFilter = (s, e) => activitySnap.docs.filter(d => inRange(d.data().last_active, s, e));
            const auDocs = auFilter(Q1_START, Q1_END);
            const uniqueAU = new Set(auDocs.map(d => d.id)).size;
            const auByMonth = MONTHS.map(m => auFilter(m.start, m.end));
            const auFields = [{ key: "_id", label: "User ID / Phone" }, { key: "last_active", label: "Last Active" }];
            const auRaw = (docs) => docs.map(d => ({ _id: d.id, ...d.data() }));

            // ── 3. Workshops ──────────────────────────────────────────────
            const wsFilter = (s, e) => workshopSnap.docs.filter(d => inRange(d.data().start_date_time, s, e));
            const wsDocs = wsFilter(Q1_START, Q1_END);
            const wsByMonth = MONTHS.map(m => wsFilter(m.start, m.end));
            const wsFields = [{ key: "title", label: "Workshop Title" }, { key: "start_date_time", label: "Date" }, { key: "type", label: "Type" }];

            // ── 4. Hours ──────────────────────────────────────────────────
            const totalHours = parseFloat((wsDocs.length * 1.5).toFixed(1));
            const hoursByMonth = wsByMonth.map(docs => parseFloat((docs.length * 1.5).toFixed(1)));

            // ── 5. Participants ───────────────────────────────────────────
            const ptFilter = (s, e) => regSnap.docs.filter(d => inRange(d.data().workshop_Date, s, e));
            const ptDocs = ptFilter(Q1_START, Q1_END);
            const ptByMonth = MONTHS.map(m => ptFilter(m.start, m.end));
            const ptFields = [{ key: "phone", label: "Phone" }, { key: "name", label: "Name" }, { key: "workshop_Date", label: "Workshop Date" }, { key: "workshop_name", label: "Workshop" }];

            // ── 6. Repeated participants ──────────────────────────────────
            const buildRepeated = (docs) => {
                const cnt = {};
                docs.forEach(d => { const p = d.data().phone; if (p) cnt[p] = (cnt[p] || 0) + 1; });
                return Object.entries(cnt).filter(([, c]) => c > 1).map(([phone, count]) => ({ phone, registrations: count }));
            };
            const repDocs = buildRepeated(ptDocs);
            const repByMonth = MONTHS.map(m => buildRepeated(ptFilter(m.start, m.end)));
            const repFields = [{ key: "phone", label: "Phone" }, { key: "registrations", label: "Times Registered" }];

            // ── 7. Portfolios ─────────────────────────────────────────────
            const pfFilter = (s, e) => portfolioSnap.docs.filter(d => inRange(d.data().created_date, s, e));
            const pfDocs = pfFilter(Q1_START, Q1_END);
            const pfByMonth = MONTHS.map(m => pfFilter(m.start, m.end));
            const pfFields = [{ key: "phone_no", label: "Phone" }, { key: "name", label: "Name" }, { key: "created_date", label: "Created Date" }];

            // ── 7b. Professions — Q1 only (filtered by created_date) ─────
            const buildProfessions = (docs) => {
                const map = {};
                docs.forEach(d => {
                    const raw = d.data ? d.data() : d;
                    const prof = (raw.profession || "").trim();
                    if (!prof) return;
                    const key = prof.toLowerCase();
                    if (!map[key]) map[key] = { profession: prof, count: 0 };
                    map[key].count++;
                });
                return Object.values(map).sort((a, b) => b.count - a.count);
            };
            // pfDocs is already filtered by created_date (Jan–Apr 2026)
            const profDocs = buildProfessions(pfDocs);
            const profByMonth = MONTHS.map(m => buildProfessions(pfFilter(m.start, m.end)));
            const profFields = [{ key: "profession", label: "Profession" }, { key: "count", label: "Portfolios" }];

            // ── 8. Collaterals ────────────────────────────────────────────
            const mcFilter = (s, e) => collateralSnap.docs.filter(d => inRange(d.data().order_date, s, e));
            const mcDocs = mcFilter(Q1_START, Q1_END);
            const mcByMonth = MONTHS.map(m => mcFilter(m.start, m.end));
            const mcFields = [{ key: "phone_no", label: "Phone" }, { key: "order_type", label: "Type" }, { key: "order_date", label: "Order Date" }];

            // ── 9 & 10. Cities / States ───────────────────────────────────
            const parFilter = (s, e) => parlourSnap.docs.filter(d => inRange(d.data().created_date, s, e));
            const parDocs = parFilter(Q1_START, Q1_END);

            // Cities and states that existed BEFORE Jan 2026 — used to exclude from "New" metrics
            const beforeQ1 = parlourSnap.docs.filter(d => {
                const dt = toDate(d.data().created_date);
                return dt && dt < Q1_START;
            });
            const preExistingCityKeys  = new Set(beforeQ1.map(d => (d.data().city  || "").trim().toLowerCase()).filter(s => s));
            const preExistingStateKeys = new Set(beforeQ1.map(d => (d.data().state || "").trim().toLowerCase()).filter(s => s));

            // Unique cities: one row per unique city name, with parlour count
            // onlyNew=true skips cities already seen before Jan 2026
            const buildUniqueCities = (docs, onlyNew = false) => {
                const map = {};
                docs.forEach(d => {
                    const city  = (d.data().city  || "").trim();
                    const state = (d.data().state || "").trim();
                    if (!city) return;
                    const key = city.toLowerCase();
                    if (onlyNew && preExistingCityKeys.has(key)) return;
                    if (!map[key]) map[key] = { city, state, parlour_count: 0 };
                    map[key].parlour_count++;
                });
                return Object.values(map).sort((a, b) => a.city.localeCompare(b.city));
            };

            // Unique states: one row per unique state name, with city count and parlour count
            // onlyNew=true skips states already seen before Jan 2026
            const buildUniqueStates = (docs, onlyNew = false) => {
                const map = {};
                docs.forEach(d => {
                    const state = (d.data().state || "").trim();
                    const city = (d.data().city || "").trim();
                    if (!state) return;
                    const key = state.toLowerCase();
                    if (onlyNew && preExistingStateKeys.has(key)) return;
                    if (!map[key]) map[key] = { state, cities: new Set(), parlour_count: 0 };
                    if (city) map[key].cities.add(city.toLowerCase());
                    map[key].parlour_count++;
                });
                return Object.values(map)
                    .map(({ cities, ...rest }) => ({ ...rest, city_count: cities.size }))
                    .sort((a, b) => a.state.localeCompare(b.state));
            };

            // New Cities = only cities that did NOT exist before Jan 2026
            const cityDocs = buildUniqueCities(parDocs, true);
            const cityByMonth = MONTHS.map(m => buildUniqueCities(parFilter(m.start, m.end), true));
            // New States = only states that did NOT exist before Jan 2026
            const stateDocs = buildUniqueStates(parDocs, true);
            const stateByMonth = MONTHS.map(m => buildUniqueStates(parFilter(m.start, m.end), true));

            const cityFields = [{ key: "city", label: "City" }, { key: "state", label: "State" }, { key: "parlour_count", label: "Parlours Added" }];
            const stateFields = [{ key: "state", label: "State" }, { key: "city_count", label: "Unique Cities" }, { key: "parlour_count", label: "Parlours Added" }];

            // ── 12. Downloaded Certificates ───────────────────────────────
            const certFilter = (s, e) => certSnap.docs.filter(d => inRange(d.data().created_date, s, e));
            const certDocs = certFilter(Q1_START, Q1_END);
            const certByMonth = MONTHS.map(m => certFilter(m.start, m.end));
            const certFields = [{ key: "phone_no", label: "Phone" }, { key: "name", label: "Name" }, { key: "created_date", label: "Downloaded On" }];

            // ── 13. Profile Types ─────────────────────────────────────────
            const prtFilter = (s, e) => profileTypeSnap.docs.filter(d => inRange(d.data().created_date, s, e));
            const buildProfileTypes = (docs) => {
                const map = {};
                docs.forEach(d => {
                    const raw = d.data ? d.data() : d;
                    const type = (raw.profile_type || "").trim();
                    if (!type) return;
                    const key = type.toLowerCase();
                    if (!map[key]) map[key] = { profile_type: type, count: 0 };
                    map[key].count++;
                });
                return Object.values(map).sort((a, b) => b.count - a.count);
            };
            const ptypeDocs = buildProfileTypes(prtFilter(Q1_START, Q1_END));
            const ptypeByMonth = MONTHS.map(m => buildProfileTypes(prtFilter(m.start, m.end)));
            const ptypeFields = [{ key: "profile_type", label: "Profile Type" }, { key: "count", label: "Count" }];

            // ── 14. Workshop Tags ─────────────────────────────────────────
            const wtFilter = (s, e) => workshopSnap.docs.filter(d => inRange(d.data().created_date, s, e));
            const buildWorkshopTags = (docs) => {
                const map = {};
                docs.forEach(d => {
                    const raw = d.data ? d.data() : d;
                    const tag = (raw.tag || "").trim();
                    if (!tag) return;
                    const key = tag.toLowerCase();
                    if (!map[key]) map[key] = { tag, count: 0 };
                    map[key].count++;
                });
                return Object.values(map).sort((a, b) => b.count - a.count);
            };
            const wtagDocs    = buildWorkshopTags(wtFilter(Q1_START, Q1_END));
            const wtagByMonth = MONTHS.map(m => buildWorkshopTags(wtFilter(m.start, m.end)));
            const wtagFields  = [{ key: "tag", label: "Tag" }, { key: "count", label: "Workshops" }];

            // ── Last FY Downloads (Apr 2025 – Mar 2026) ──────────────────
            const fyDlDocs    = downloadSnap.docs.filter(d => inRange(d.data().created_date, FY_START, FY_END));
            const fyDlByMonth = FY_MONTHS.map(m => downloadSnap.docs.filter(d => inRange(d.data().created_date, m.start, m.end)));
            setFyDownloads({
                total: fyDlDocs.length,
                byMonth: fyDlByMonth.map(a => a.length),
                rawTotal: fyDlDocs.map(d => d.data()),
                rawByMonth: fyDlByMonth.map(a => a.map(d => d.data())),
                fields: dlFields,
            });

            setMetrics([
                {
                    title: "New App Downloads", suffix: "",
                    total: dlDocs.length, byMonth: dlByMonth.map(a => a.length),
                    rawTotal: dlDocs.map(d => d.data()),
                    rawByMonth: dlByMonth.map(a => a.map(d => d.data())),
                    fields: dlFields,
                },
                {
                    title: "Active Users", suffix: "",
                    total: uniqueAU, byMonth: auByMonth.map(a => new Set(a.map(d => d.id)).size),
                    rawTotal: auRaw(auDocs),
                    rawByMonth: auByMonth.map(a => auRaw(a)),
                    fields: auFields,
                },
                {
                    title: "New Workshops Added", suffix: "",
                    total: wsDocs.length, byMonth: wsByMonth.map(a => a.length),
                    rawTotal: wsDocs.map(d => d.data()),
                    rawByMonth: wsByMonth.map(a => a.map(d => d.data())),
                    fields: wsFields,
                },
                {
                    title: "Skill Training Hours", suffix: " hrs",
                    total: totalHours, byMonth: hoursByMonth,
                    rawTotal: wsDocs.map(d => d.data()),
                    rawByMonth: wsByMonth.map(a => a.map(d => d.data())),
                    fields: wsFields,
                },
                {
                    title: "Total Participants Trained", suffix: "",
                    total: ptDocs.length, byMonth: ptByMonth.map(a => a.length),
                    rawTotal: ptDocs.map(d => d.data()),
                    rawByMonth: ptByMonth.map(a => a.map(d => d.data())),
                    fields: ptFields,
                },
                {
                    title: "Repeated Participants", suffix: "",
                    total: repDocs.length, byMonth: repByMonth.map(a => a.length),
                    rawTotal: repDocs,
                    rawByMonth: repByMonth,
                    fields: repFields,
                },
                {
                    title: "Portfolios Created", suffix: "",
                    total: pfDocs.length, byMonth: pfByMonth.map(a => a.length),
                    rawTotal: pfDocs.map(d => d.data()),
                    rawByMonth: pfByMonth.map(a => a.map(d => d.data())),
                    fields: pfFields,
                },
                {
                    title: "Marketing Collaterals Created", suffix: "",
                    total: mcDocs.length, byMonth: mcByMonth.map(a => a.length),
                    rawTotal: mcDocs.map(d => d.data()),
                    rawByMonth: mcByMonth.map(a => a.map(d => d.data())),
                    fields: mcFields,
                },
                {
                    title: "New Cities", suffix: "",
                    total: cityDocs.length, byMonth: cityByMonth.map(a => a.length),
                    rawTotal: cityDocs,
                    rawByMonth: cityByMonth,
                    fields: cityFields,
                },
                {
                    title: "New States", suffix: "",
                    total: stateDocs.length, byMonth: stateByMonth.map(a => a.length),
                    rawTotal: stateDocs,
                    rawByMonth: stateByMonth,
                    fields: stateFields,
                },
                // {
                //     title: "Unique Professions", suffix: "",
                //     total: profDocs.length,      byMonth: profByMonth.map(a => a.length),
                //     rawTotal: profDocs,
                //     rawByMonth: profByMonth,
                //     fields: profFields,
                // },
                {
                    title: "Downloaded Certificates", suffix: "",
                    total: certDocs.length, byMonth: certByMonth.map(a => a.length),
                    rawTotal: certDocs.map(d => d.data()),
                    rawByMonth: certByMonth.map(a => a.map(d => d.data())),
                    fields: certFields,
                },
                {
                    title: "Profile Types", suffix: "",
                    total: ptypeDocs.length, byMonth: ptypeByMonth.map(a => a.length),
                    rawTotal: ptypeDocs,
                    rawByMonth: ptypeByMonth,
                    fields: ptypeFields,
                },
                {
                    title: "Workshop Tags", suffix: "",
                    total: wtagDocs.length, byMonth: wtagByMonth.map(a => a.length),
                    rawTotal: wtagDocs,
                    rawByMonth: wtagByMonth,
                    fields: wtagFields,
                },
            ]);
        } catch (err) {
            console.error(err);
            setError("Failed to load metrics. Check console for details.");
        }
        setLoading(false);
    };

    return (
        <>
            <DataModal modal={modal} onClose={() => setModal(null)} />

            {/* HEADER */}
            <div style={{
                background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)",
                padding: "20px 28px", display: "flex", justifyContent: "space-between", alignItems: "center",
            }}>
                <div>
                    <h4 className="text-white fw-bold mb-0">📊 Data Metrics — Q1 2026</h4>
                    <small style={{ color: "#a0aec0" }}>January · February · March · April · May 2026</small>
                </div>
                <div className="d-flex gap-3 align-items-center">
                    <Link to="/data_metrix_profile" className="btn btn-sm btn-outline-light rounded-pill px-3">By Profile →</Link>
                    <button className="btn btn-sm btn-outline-light rounded-pill px-3" onClick={fetchAll} disabled={loading}>
                        {loading ? "⏳ Loading…" : "🔄 Refresh"}
                    </button>
                    <Link to="/"><img src="/images/menubutton.png" alt="Menu" style={{ height: "2rem", filter: "invert(1)" }} /></Link>
                </div>
            </div>

            <div style={{ background: "#f0f4f8", minHeight: "100vh", padding: "28px 20px" }}>

                <div className="d-flex flex-wrap gap-2 mb-4">
                    {MONTHS.map(m => (
                        <span key={m.label} className="badge px-3 py-2" style={{ background: "#1a1a2e", fontSize: "12px", borderRadius: "20px" }}>
                            {m.label}
                        </span>
                    ))}
                    <span className="badge px-3 py-2 ms-2" style={{ background: "#e2e8f0", color: "#64748b", fontSize: "12px", borderRadius: "20px" }}>
                        Click any number to inspect records
                    </span>
                </div>

                {error && <div className="alert alert-danger rounded-3">{error}</div>}

                {loading ? (
                    <div className="row g-4">
                        {Array(12).fill(0).map((_, i) => (  // 12 metric cards
                            <div className="col-lg-4 col-md-6" key={i}>
                                <div className="card border-0 shadow-sm" style={{ borderRadius: "16px", height: "150px", background: "#e2e8f0" }}>
                                    <div className="card-body d-flex align-items-center justify-content-center">
                                        <div className="spinner-border spinner-border-sm text-secondary" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : metrics && (
                    <>
                        {/* SUMMARY BAR */}
                        <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: "16px", background: "linear-gradient(135deg, #1a1a2e, #0f3460)", padding: "20px 24px" }}>
                            <div className="row g-0">
                                {metrics.map((m, i) => (
                                    <div
                                        key={i}
                                        className="col-6 col-md-4 col-lg-2 text-center"
                                        onClick={() => openModal(m.title, ICONS[i], CARD_COLORS[i], m.rawTotal, m.fields, "Q1 2026 Total")}
                                        style={{
                                            padding: "14px 8px",
                                            cursor: "pointer",
                                            borderBottom: i < 8 ? "1px solid rgba(255,255,255,0.07)" : "none",
                                            borderRight: "1px solid rgba(255,255,255,0.07)",
                                        }}
                                        title="Click to inspect"
                                    >
                                        <div style={{ fontSize: "11px", marginBottom: "4px" }}>{ICONS[i]}</div>
                                        <div style={{ fontSize: "1.6rem", fontWeight: "800", color: CARD_COLORS[i], lineHeight: 1 }}>
                                            {m.total}{m.suffix}
                                        </div>
                                        <div style={{ fontSize: "10px", color: "#a0aec0", lineHeight: "1.4", marginTop: "5px" }}>
                                            {m.title}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* METRIC CARDS */}
                        <div className="row g-4">
                            {metrics.map((m, i) => (
                                <div className="col-lg-4 col-md-6" key={i}>
                                    <div className="card border-0 shadow-sm h-100" style={{ borderRadius: "16px", overflow: "hidden" }}>

                                        {/* Card Header — click total */}
                                        <div
                                            style={{ background: CARD_COLORS[i], padding: "18px 22px 14px", cursor: "pointer" }}
                                            onClick={() => openModal(m.title, ICONS[i], CARD_COLORS[i], m.rawTotal, m.fields, "Q1 2026 Total")}
                                            title="Click to see all Q1 records"
                                        >
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <div style={{ fontSize: "1.8rem" }}>{ICONS[i]}</div>
                                                    <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "13px", marginTop: "6px", fontWeight: 500 }}>
                                                        {m.title}
                                                    </div>
                                                    <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "10px", marginTop: "2px" }}>
                                                        tap to inspect ↗
                                                    </div>
                                                </div>
                                                <div style={{ fontSize: "2.8rem", fontWeight: "800", color: "#fff", lineHeight: 1 }}>
                                                    {m.total}{m.suffix}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Monthly Breakdown — each bar/number clickable */}
                                        <div style={{ background: "#fff", padding: "12px 22px" }}>
                                            <div className="d-flex justify-content-between">
                                                {MONTHS.map((month, mi) => {
                                                    const val = m.byMonth[mi] ?? 0;
                                                    const max = Math.max(...m.byMonth, 1);
                                                    const pct = Math.round((val / max) * 100);
                                                    return (
                                                        <div
                                                            key={mi}
                                                            className="text-center flex-fill"
                                                            style={{ cursor: "pointer" }}
                                                            onClick={() => openModal(m.title, ICONS[i], CARD_COLORS[i], m.rawByMonth[mi], m.fields, month.label)}
                                                            title={`Click to inspect ${month.label} records`}
                                                        >
                                                            <div style={{ height: "40px", display: "flex", alignItems: "flex-end", justifyContent: "center", marginBottom: "4px" }}>
                                                                <div style={{
                                                                    width: "14px",
                                                                    height: `${Math.max(pct, 8)}%`,
                                                                    background: CARD_COLORS[i],
                                                                    borderRadius: "3px 3px 0 0",
                                                                    opacity: 0.85,
                                                                    minHeight: "4px",
                                                                    transition: "opacity 0.2s",
                                                                }}
                                                                    onMouseEnter={e => e.target.style.opacity = 1}
                                                                    onMouseLeave={e => e.target.style.opacity = 0.85}
                                                                />
                                                            </div>
                                                            <div style={{ fontSize: "13px", fontWeight: "700", color: CARD_COLORS[i] }}>
                                                                {val}{m.suffix}
                                                            </div>
                                                            <div style={{ fontSize: "8px", color: "#94a3b8", marginTop: "2px" }}>
                                                                {month.label}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
                {/* LAST FY DOWNLOADS */}
                {fyDownloads && (
                    <div className="mt-5">
                        <div className="d-flex align-items-center gap-3 mb-3">
                            <h6 className="fw-bold mb-0" style={{ color: "#1a1a2e" }}>📥 Last FY App Downloads</h6>
                            <span className="badge px-3 py-2" style={{ background: "#1a1a2e", fontSize: "12px", borderRadius: "20px" }}>
                                Apr 2025 – Mar 2026
                            </span>
                        </div>
                        <div className="card border-0 shadow-sm" style={{ borderRadius: "16px", overflow: "hidden" }}>
                            <div
                                style={{ background: "#4361ee", padding: "18px 24px", cursor: "pointer" }}
                                onClick={() => openModal("Last FY Downloads", "📥", "#4361ee", fyDownloads.rawTotal, fyDownloads.fields, "FY 2025-26 Total")}
                                title="Click to inspect all FY records"
                            >
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <div style={{ color: "rgba(255,255,255,0.85)", fontSize: "14px", fontWeight: 500 }}>
                                            New App Downloads — FY 2025-26
                                        </div>
                                        <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "11px", marginTop: "2px" }}>
                                            tap to inspect ↗
                                        </div>
                                    </div>
                                    <div style={{ fontSize: "3rem", fontWeight: "800", color: "#fff", lineHeight: 1 }}>
                                        {fyDownloads.total}
                                    </div>
                                </div>
                            </div>
                            <div style={{ background: "#fff", padding: "16px 22px" }}>
                                <div className="d-flex justify-content-between flex-wrap gap-2">
                                    {FY_MONTHS.map((month, mi) => {
                                        const val = fyDownloads.byMonth[mi] ?? 0;
                                        const max = Math.max(...fyDownloads.byMonth, 1);
                                        const pct = Math.round((val / max) * 100);
                                        return (
                                            <div
                                                key={mi}
                                                className="text-center flex-fill"
                                                style={{ cursor: "pointer", minWidth: "50px" }}
                                                onClick={() => openModal("Last FY Downloads", "📥", "#4361ee", fyDownloads.rawByMonth[mi], fyDownloads.fields, month.label)}
                                                title={`Click to inspect ${month.label} records`}
                                            >
                                                <div style={{ height: "50px", display: "flex", alignItems: "flex-end", justifyContent: "center", marginBottom: "4px" }}>
                                                    <div style={{
                                                        width: "16px",
                                                        height: `${Math.max(pct, 8)}%`,
                                                        background: "#4361ee",
                                                        borderRadius: "3px 3px 0 0",
                                                        opacity: 0.8,
                                                        minHeight: "4px",
                                                        transition: "opacity 0.2s",
                                                    }}
                                                        onMouseEnter={e => e.target.style.opacity = 1}
                                                        onMouseLeave={e => e.target.style.opacity = 0.8}
                                                    />
                                                </div>
                                                <div style={{ fontSize: "13px", fontWeight: "700", color: "#4361ee" }}>{val}</div>
                                                <div style={{ fontSize: "9px", color: "#94a3b8", marginTop: "2px" }}>{month.label}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </>
    );
}
